const registrationFreemiumTemplate = `
<form>
<div style="border:1px solid white;text-align=center;color:white;">
        <span style="text-align=center">Please Hang on for a moment....</span>
    </div>
    </form>
`;
export default registrationFreemiumTemplate;
